import { render } from "./SVGMagicApply.vue?vue&type=template&id=3ae9fed0"
import script from "./SVGMagicApply.vue?vue&type=script&lang=js"
export * from "./SVGMagicApply.vue?vue&type=script&lang=js"

import exportComponent from "/home/devops/tool_cases/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__